import React, { createContext, useState } from 'react';

export const MainContext = createContext();

export const MainProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  return (
    <MainContext.Provider
      value={{
        isMobile,
        setIsMobile,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};
